import React, { useEffect } from "react"
import { TextFieldSeeker } from "@ui-seeker/core"
import { useValidatorSeeker } from "@ui-seeker/app"
import { object, string } from "yup"
import useAutoEuropeDataInfo from "Pages/AutoEuropeTool/Page/@hooks/useDataInfo"
import { autoEuropeDrawerData, autoEuropeDrawerErrors } from "Pages/AutoEuropeTool/Page/@signals"

export default function AutoEuropeAgencyId() {
	const { dataInfo, setDataInfo } = useAutoEuropeDataInfo(autoEuropeDrawerData.peek().agencyId ?? null)

	const { errors, isValid } = useValidatorSeeker({ agencyId: dataInfo.value }, object({
		agencyId: string()
			.required("Agency ID is required")
			.min(1, "Agency ID is required")
	}))

	useEffect(() => {
		autoEuropeDrawerErrors.value = { ...autoEuropeDrawerErrors.value, agencyId: isValid }
	}, [JSON.stringify(errors)])

	return <TextFieldSeeker
		label="Agency ID"
		value={dataInfo.value ?? ""}
		onChange={e => setDataInfo(e.target.value, "agencyId")}
		error={errors?.agencyId}
	/>
}